// Gedeelde presentatie-constanten en mini-helpers van de Offerte Generator.
// Verhuisd uit OffertesGenerator.jsx zodat de documentweergave-componenten
// (OfferteDocument, OfferteEigenschappen, …) ze kunnen importeren zonder
// circulaire imports.
import Link from '@mui/material/Link';

// Offerte-accent (indigo) — consistent doorgevoerd in header, kaarten en knoppen.
export const ACCENT = { main: '#4f46e5', dark: '#4338ca', soft: '#eef2ff', tile: '#e0e7ff' };

// Eenheden zoals Gripp ze kent (Instellingen → Eenheden; EN/punt-varianten mappen server-side)
export const UNIT_OPTIONS = ['stuk', 'uur', 'dag', 'km', 'minuut film', 'prijs'];

// Verplichte Gripp-velden (Vrije velden op de offerte) — EXACT de keuzelijstwaarden
// zoals in Gripp geconfigureerd (bron: backend GRIPP_FIELD_VALUES). Zo levert een
// handmatige keuze nooit een ongeldige waarde op die stil naar 'Nvt' wordt omgezet.
export const GRIPP_FIELD_OPTIONS = {
  doel: ['Branding', 'Arbeidsmarkt communicatie', 'Interne communicatie', 'Corporate communicatie', 'VeryVideo', 'Sales', 'Training'],
  dienst: ['Volledige productie', 'Diagnose', 'Concept & strategie', 'Productie (opname)', 'Postproductie', 'Kanaalbeheer', 'Verhuur', 'Workshop / Training'],
  omvang: ['S', 'M', 'L', 'XL'],
  projecttype: ['Bedrijfsfilm', 'Projectfilm', 'Productfilm', 'Commercial', 'Radiocommercial', 'Testimonial', 'Explainer',
    'Interview', 'Eventfilm', 'Registratie', 'Animatie', 'Podcast', 'Fotografie', 'Webinar', 'Infographic', 'Shortform video', 'Nvt'],
};
export const GRIPP_FIELD_LABELS = { doel: 'Doel', dienst: 'Dienst', omvang: 'Omvang', projecttype: 'Projecttype' };

// Kale URL's in assistent-antwoorden klikbaar maken.
export function linkifyText(text) {
  const parts = String(text || '').split(/(https?:\/\/[^\s)]+)/g);
  return parts.map((part, i) => /^https?:\/\//.test(part)
    ? <Link key={i} href={part} target="_blank" rel="noopener noreferrer" sx={{ wordBreak: 'break-all' }}>{part}</Link>
    : part);
}
